/**
 * Featured Showcase web component
 * Syncs accordion tabs with showcase images via data-showcase-tab-id / data-showcase-image
 */
class FeaturedShowcase extends HTMLElement {
  connectedCallback() {
    const init = () => {
      if (window.Accordion) return this.setup();
      setTimeout(init, 10);
    };
    init();
  }

  setup() {
    const accordion = this.querySelector('accordion-component');
    const imageGroup = this.querySelector('[data-showcase-image-group]');
    if (!accordion || !imageGroup) return;

    const onInit = () => {
      accordion.open(0);
      const skeleton = imageGroup.querySelector('[data-showcase-skeleton]');

      if (!skeleton) return;

      if (skeleton) skeleton.remove();
      accordion.querySelectorAll('[data-showcase-image]').forEach((image, i) => {
        image.style.display = i === 0 ? 'block' : 'none';
        imageGroup.appendChild(image);
      });
      
    };

    accordion.addEventListener('accordion:init', onInit);
    if (accordion.accordion) onInit();

    accordion.addEventListener('accordion:open', (e) => {
      const tabId = e.detail?.element?.getAttribute?.('data-showcase-tab-id');
      if (!tabId) return;
      imageGroup.querySelectorAll('[data-showcase-image]').forEach((img) => {
        img.style.display = img.getAttribute('data-showcase-image') === tabId ? 'block' : 'none';
      });
    });
  }
}

if (!window.customElements.get('featured-showcase')) {
  window.customElements.define('featured-showcase', FeaturedShowcase);
}
